import { BrowserModule } from '@angular/platform-browser';
import { APP_INITIALIZER, NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClientModule } from '@angular/common/http';
import { ConfigfileService } from './_services/configfile.service';



const appConfig=(config:ConfigfileService)=>{
  return()=>{
    return config.loadConfig()
  }
}
@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    HttpClientModule,
  ],
  providers: [HttpClientModule,{provide:APP_INITIALIZER,
    useFactory:appConfig,multi:true,deps:[ConfigfileService]}],
  bootstrap: [AppComponent]
})
export class AppModule { }
